module.exports = __webpack_public_path__ + "static/media/brewery_tank_mural_rendering_3_2007.45445098.webp";